import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function VideoPlayCircle(): React.ReactElement {
  return (
    <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="33" cy="33" r="32.5" fill="white" fillOpacity="0.05" stroke="white"/>
      <path d="M46.3516 32.1344C47.0182 32.5193 47.0182 33.4815 46.3516 33.8664L27.0766 44.9948C26.4099 45.3797 25.5766 44.8986 25.5766 44.1288L25.5766 21.872C25.5766 21.1022 26.4099 20.621 27.0766 21.0059L46.3516 32.1344Z" fill="white"/>
      <path d="M46.1016 32.5674C46.4349 32.7598 46.4349 33.241 46.1016 33.4334L26.8266 44.5618C26.4932 44.7543 26.0766 44.5137 26.0766 44.1288L26.0766 21.872C26.0766 21.4871 26.4932 21.2465 26.8266 21.439L46.1016 32.5674Z" stroke="#DFDFDF" strokeOpacity="0.05"/>
    </svg>
  );
}
